// @flow
import isEqual from 'react-fast-compare';
import Mobile from './Mobile/Mobile';
import React from 'react';
import Seo from './Seo/Seo';
import styles from './LAFooter.module.scss';
import Support from './Support/Support';
import Trust from './Trust/Trust';

type Props = {|
    baseUrl: string,
    classicBaseUrl: string,
    mobileBrowserOS: string,
    openFeedbackModal: Function,
    openHealthcheckModal: Function,
    windowWidth: number,
    year: number,
|};

const LAFooter = (props: Props) => {
    const {
        baseUrl,
        classicBaseUrl,
        mobileBrowserOS,
        openFeedbackModal,
        openHealthcheckModal,
        windowWidth,
        year,
    } = props;

    return (
        <div className={styles.footer}>
            <Mobile mobileBrowserOS={mobileBrowserOS} windowWidth={windowWidth} />
            <Trust />
            <Seo />
            <Support
                baseUrl={baseUrl}
                classicBaseUrl={classicBaseUrl}
                openFeedbackModal={openFeedbackModal}
                openHealthcheckModal={openHealthcheckModal}
                year={year}
            />
        </div>
    );
};

export default React.memo<Props>(LAFooter, isEqual);
